import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f7230664")

_pushScopeId("data-v-f7230664")
const _hoisted_1 = { class: "trade-item" }
const _hoisted_2 = { class: "brief df-middle f-md row" }
const _hoisted_3 = { class: "flex-2 df-middle" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Symbol")
const _hoisted_5 = { class: "value df-middle" }
const _hoisted_6 = { class: "flex-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Direction")
const _hoisted_8 = { class: "flex-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Quantity")
const _hoisted_10 = { class: "flex-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Profit")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("$0")
const _hoisted_13 = { class: "flex-1 t-right" }
const _hoisted_14 = { ref: "acc" }
const _hoisted_15 = { class: "accordion__content more f-md" }
const _hoisted_16 = { class: "row d-f" }
const _hoisted_17 = { class: "flex-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Volume")
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "flex-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Entry Price")
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "flex-3" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Entry Time")
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_27 = { class: "row d-f" }
const _hoisted_28 = { class: "flex-2" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("T/P")
const _hoisted_30 = { class: "flex-2" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("S/L")
const _hoisted_32 = { class: "flex-2" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Commission")
const _hoisted_34 = { class: "flex-2" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Swap")
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_37 = { class: "row d-f" }
const _hoisted_38 = { class: "flex-2" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Used Margin")
const _hoisted_40 = { class: "flex-2" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Leverage")
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "flex-3" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Profit per pip")
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_47 = { class: "row d-f" }
const _hoisted_48 = { class: "flex-2" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Purchase")
const _hoisted_50 = { class: "flex-4" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("ID")
const _hoisted_52 = { class: "value" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "flex-3" }, null, -1)
const _hoisted_54 = {
  key: 0,
  class: "tip c-tip py-8 f-sm df-middle"
}
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Position with coupons will be automatically closed after the market is closed ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_ColorText = _resolveComponent("ColorText")
  const _component_money = _resolveComponent("money")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Date = _resolveComponent("Date")
  const _component_TheTradeLimitDisplay = _resolveComponent("TheTradeLimitDisplay")

  return (_openBlock(), _createBlock("div", {
    class: "position anchor",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSlide && _ctx.toggleSlide(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_t, { class: "label" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.prop('code', _ctx.order)) + " ", 1),
            (_ctx.byCoupon)
              ? (_openBlock(), _createBlock(_component_Pic, {
                  key: 0,
                  src: "trade/credit",
                  width: "12",
                  height: "12",
                  class: "ml-4"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_t, {
            path: "symbol_8",
            class: "label"
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_t, { custom: "" }, {
            default: _withId(({td, t}) => [
              _createVNode(_component_ColorText, {
                class: "f-medium",
                display: [t('symbol_10') || 'Sell', t('symbol_9') || 'Buy'],
                value: _ctx.prop('type', _ctx.order) - 2
              }, null, 8, ["display", "value"])
            ]),
            _: 1
          }),
          (_ctx.order.source)
            ? (_openBlock(), _createBlock(_component_Pic, {
                key: 0,
                src: "trade/documentary",
                width: "16",
                height: "16",
                class: "ml-8"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_t, { class: "label" }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode("span", null, _toDisplayString(_ctx.prop('orderNumber', _ctx.order)) + "Lots", 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_t, {
            path: "symbol_12",
            class: "label"
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_money, {
            v: _ctx.profit,
            class: "value"
          }, {
            default: _withId(({text, origin}) => [
              (_ctx.byCoupon && Number(origin) < 0)
                ? (_openBlock(), _createBlock(_component_ColorText, {
                    key: 0,
                    value: 0,
                    class: "mr-4"
                  }, {
                    default: _withId(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ColorText, {
                value: Number(origin),
                class: _ctx.byCoupon && Number(origin) < 0 ? 't-through': ''
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                _: 2
              }, 1032, ["value", "class"])
            ]),
            _: 1
          }, 8, ["v"])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Icon, {
            name: _ctx.show ? 'caret-up' : 'caret-down',
            class: ["toggle-icon c-tip", {up: _ctx.show}],
            sm: ""
          }, null, 8, ["name", "class"]),
          _createVNode(_component_Pic, {
            src: "icons/edit",
            width: "16",
            height: "16",
            class: "mx-8 v-middle",
            onClick: _withModifiers(_ctx.edit, ["stop"])
          }, null, 8, ["onClick"]),
          _createVNode(_component_Icon, {
            name: "close",
            class: "br-sm bg-primary c-white",
            sm: "",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.close(_ctx.order.orderId)), ["stop"]))
          })
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_t, {
                path: "symbol_7",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.order.weight * (_ctx.order.orderNumber / 0.01)) + " " + _toDisplayString(_ctx.prop('unit', _ctx.order)), 1)
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_t, {
                path: "symbol_15",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.prop('createPrice', _ctx.order)), 1)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_t, {
                path: "symbol_16",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_Date, {
                class: "value f-xs",
                format: "MM-dd-yyyy HH:mm:ss",
                time: _ctx.prop('createTime', _ctx.order)
              }, null, 8, ["time"])
            ]),
            _hoisted_25,
            _hoisted_26
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode(_component_t, {
                path: "symbol_13",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_29
                ]),
                _: 1
              }),
              _createVNode(_component_TheTradeLimitDisplay, {
                class: "value",
                value: Number(_ctx.prop('stopProfitPoint', _ctx.order))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_t, {
                path: "symbol_14",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_31
                ]),
                _: 1
              }),
              _createVNode(_component_TheTradeLimitDisplay, {
                class: "value",
                value: Number(_ctx.prop('stopLossPoint', _ctx.order))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode(_component_t, {
                path: "symbol_17",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_33
                ]),
                _: 1
              }),
              _createVNode(_component_money, {
                class: "value",
                v: _ctx.prop('fee', _ctx.order)
              }, null, 8, ["v"])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode(_component_t, {
                path: "symbol_18",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_35
                ]),
                _: 1
              }),
              _createVNode(_component_money, {
                class: "value",
                v: _ctx.prop('deferred', _ctx.order)
              }, null, 8, ["v"])
            ]),
            _hoisted_36
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode(_component_t, { class: "label" }, {
                default: _withId(() => [
                  _hoisted_39
                ]),
                _: 1
              }),
              _createVNode(_component_money, {
                class: "value",
                v: _ctx.prop('buyMoney', _ctx.order)
              }, null, 8, ["v"])
            ]),
            _createVNode("div", _hoisted_40, [
              _createVNode(_component_t, {
                path: "transactionhistory_25",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_41
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_42, "1:" + _toDisplayString(_ctx.prop('lever', _ctx.order)), 1)
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode(_component_t, {
                path: "transactionhistory_29",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_44
                ]),
                _: 1
              }),
              _createVNode("span", null, _toDisplayString(_ctx.order.yk * (_ctx.order.orderNumber / 0.01)) + " " + _toDisplayString(_ctx.prop('ykUnit', _ctx.order)), 1)
            ]),
            _hoisted_45,
            _hoisted_46
          ]),
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode(_component_t, {
                class: "label",
                path: "credit_3"
              }, {
                default: _withId(() => [
                  _hoisted_49
                ]),
                _: 1
              }),
              _createVNode(_component_t, {
                path: _ctx.byCoupon ? 'credit_5': 'credit_4',
                class: "value"
              }, null, 8, ["path"])
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode(_component_t, {
                path: "credit_6",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_51
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_52, _toDisplayString(_ctx.order.orderNum), 1)
            ]),
            _hoisted_53
          ])
        ])
      ], 512),
      (_ctx.byCoupon)
        ? (_openBlock(), _createBlock("div", _hoisted_54, [
            _createVNode(_component_Icon, {
              name: "warn",
              sm: "",
              class: "mr-4"
            }),
            _createVNode(_component_t, { path: "symbol_19" }, {
              default: _withId(() => [
                _hoisted_55
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})